var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContentManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5333 3.47335C12.26 3.20002 11.7867 3.38668 11.7867 3.76668V6.09335C11.7867 7.06668 12.6133 7.87335 13.62 7.87335C14.2533 7.88002 15.1333 7.88002 15.8867 7.88002C16.2667 7.88002 16.4667 7.43335 16.2 7.16668C15.24 6.20002 13.52 4.46002 12.5333 3.47335Z",
    fill: "#FF66A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 8.79331H13.74C12.16 8.79331 10.8733 7.50665 10.8733 5.92665V3.99998C10.8733 3.63331 10.5733 3.33331 10.2067 3.33331H7.38C5.32667 3.33331 3.66667 4.66665 3.66667 7.04665V12.9533C3.66667 15.3333 5.32667 16.6666 7.38 16.6666H12.62C14.6733 16.6666 16.3333 15.3333 16.3333 12.9533V9.45998C16.3333 9.09331 16.0333 8.79331 15.6667 8.79331ZM9.66667 13.8333H7C6.72667 13.8333 6.5 13.6066 6.5 13.3333C6.5 13.06 6.72667 12.8333 7 12.8333H9.66667C9.94 12.8333 10.1667 13.06 10.1667 13.3333C10.1667 13.6066 9.94 13.8333 9.66667 13.8333ZM11 11.1666H7C6.72667 11.1666 6.5 10.94 6.5 10.6666C6.5 10.3933 6.72667 10.1666 7 10.1666H11C11.2733 10.1666 11.5 10.3933 11.5 10.6666C11.5 10.94 11.2733 11.1666 11 11.1666Z",
    fill: "#FF66A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentManagement);
export default __webpack_public_path__ + "static/media/content-management.2ab7a8fe8804d72e25e9762cdc043077.svg";
export { ForwardRef as ReactComponent };